export function formatBDMobile(
  mobile: string,
  mode?: 'view' | 'create',
): string | null {
  if (!mobile) return null;

  // Remove all non-digit characters
  let normalized = mobile.replace(/\D/g, '');

  // Remove leading 0 or 880
  if (normalized.startsWith('0')) {
    normalized = normalized.slice(1);
  } else if (normalized.startsWith('880')) {
    normalized = normalized.slice(3);
  }

  // Check valid BD operator code
  const validOperators = /^(13|14|15|16|17|18|19)/;
  if (!validOperators.test(normalized) || normalized.length !== 10) {
    return null;
  }

  // Format: +880 17 1234-5678
  const formattedForView = `+880 ${normalized.slice(0, 4)}-${normalized.slice(
    4,
  )}`;
  const formattedForCreate = `+880${normalized.slice(0, 4)}${normalized.slice(
    4,
  )}`;

  return mode === 'create' ? formattedForCreate : formattedForView;
}
